import { MaxHeight } from "../Basic/MaxHeight";
import { Flex } from "antd";
import { BarLoader } from "react-spinners";
import Center from "../Basic/Center";

const DefaultLoading = ({ loadingToken }) => {
    return (
        <MaxHeight>
            {/* <FormHeader /> */}
            <Center>
                <Flex vertical gap={12}>
                    <img
                        preview={false}
                        src={"/logo.png"}
                        // height={30}
                        className="md:w-[10vw] w-[30vw]"
                    />
                    <div
                        style={{
                            borderRadius: "5px",
                            overflow: "hidden",
                        }}
                        className="md:w-[10vw] w-[30vw]"
                    >
                        <BarLoader color={"rgb(30, 47, 105)"} width={"100%"} />
                    </div>
                </Flex>
            </Center>
        </MaxHeight>
    );
};

export default DefaultLoading;
